import protocolCheck from './protocolcheck'
import './testMobile'
import appConst from '../constant/appConst'
import { getMatchingPlayerUrlOrigin } from '../utils/utils'

export const redirectToAppMobile = (appUrl) => {
	let storeUrl
	let redirectUrl
	const uagent = navigator.userAgent.toLowerCase()
	if (/android/i.test(uagent)) {
		storeUrl = appConst.CONFIG.ANDROID_STORE_URL
		redirectUrl = `intent://${appUrl}#Intent;scheme=qobuzapp;package=com.qobuz.music;S.browser_fallback_url=${storeUrl};end`
		window.location = redirectUrl
	} else if ((/iphone/i.test(uagent) || /ipod/i.test(uagent) || /ipad/i.test(uagent)) && (/WebKit/i.test(uagent) || /CriOS/i.test(uagent))) {
		storeUrl = appConst.CONFIG.IOS_STORE_URL
		setTimeout(() => {
			if (!document.webkitHidden) window.location = storeUrl
		}, 1000)
		window.location = `qobuzapp://${appUrl}`
	}
}

const getUrl = (type, id) => {
	switch (type) {
		case 'story':
			return `magazine/story/${id}`
		default:
			return `${type}/${id}`
	}
}

export default (type, id) => {
	const appUrl = getUrl(type, id)
	if (window.mobilecheck()) {
		redirectToAppMobile(appUrl)
	} else {
		const playerUrlOrigin = getMatchingPlayerUrlOrigin()
		protocolCheck(
			`qobuzapp://${appUrl}`,
			() => window.open(`${playerUrlOrigin}/${appUrl}`, '_blank')
		)
	}
}



// WEBPACK FOOTER //
// ./src/utils/redirectToApp.js